import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export default api;

export async function downloadFile(path, fallbackName) {
  const res = await api.get(path, { responseType: "blob" });
  const dispo = res.headers["content-disposition"] || "";
  const m = dispo.match(/filename="?([^";]+)"?/);
  const name = m ? m[1] : fallbackName;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function apiError(err, fallback = "Something went wrong") {
  return err?.response?.data?.detail || fallback;
}
